import React from "react";
import styled from "styled-components";
import FlexContainer from "./FlexContainer";

const StyledButton = styled.button`
    text-align: center;
    font-family: Manrope, Helvetica, sans-serif;
    font-size: 0.8750em;
    color: #FFFFFF;
    font-weight: 500;
    
    background: #171A22;
    border: none;
    border-radius: 10px !important;
    padding: 5px;
    width: ${props => props.width || "130px"};
    height: ${props => props.height || "40px"};
    cursor: pointer;
`;

class BrowseFileButton extends React.Component {
    constructor(props) {
        super(props);
        this.fileInput = React.createRef();
    }

    render() {
        const { children, onChange } = this.props;
        return (
            <FlexContainer>
                <StyledButton 
                    width={this.props.width}
                    height={this.props.height}
                    onClick={() => this.fileInput.current.click()}>
                    {children}
                </StyledButton>
                <input
                    ref={this.fileInput}
                    style={{ display: "none" }}
                    type="file"
                    onChange={e => onChange([...e.target.files])} />
            </FlexContainer>
        );
    }
}

export default BrowseFileButton;
